import React from 'react';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import Carousel from '../../../../../../common/molecules/Carousel/views/Carousel';
import { breakpoints } from '../../../../../../../../styles/themes/TCP/mediaQuery';

const ProductImageCarousel = ({ children, handleChange }) => {
  return (
    <Carousel
      options={{
        className: 'slider variable-width',
        centerMode: false,
        autoplay: false,
        arrows: false,
        fade: false,
        swipeToSlide: false,
        dots: false,
        dotsClass: 'slick-dots',
        slidesToShow: 1,
        swipe: true,
        slide: true,
        infinite: false,
        slidesToScroll: 1,
        afterChange: (index) => {
          if (typeof index === 'number') {
            handleChange(index);
          }
        },
        responsive: [
          {
            breakpoint: breakpoints.medium,
            settings: {
              slidesToShow: 1,
              arrows: false,
            },
          },
          {
            breakpoint: breakpoints.small,
            settings: {
              slidesToShow: 1,
              arrows: false,
            },
          },
        ],
      }}
      carouselConfig={{
        autoplay: false,
      }}
    >
      {children}
    </Carousel>
  );
};

export default errorBoundary(ProductImageCarousel);
